import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reactions-wrapper"
}
const _hoisted_2 = { class: "reaction-emoji" }
const _hoisted_3 = {
  key: 0,
  class: "reaction-details"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "details-loading"
}
const _hoisted_6 = {
  key: 1,
  class: "reaction-button--thumbnail"
}
const _hoisted_7 = {
  key: 3,
  class: "reaction-button--thumbnail"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_NcPopover = _resolveComponent("NcPopover")
  const _component_IconHeartOutline = _resolveComponent("IconHeartOutline")
  const _component_IconEmoticonPlusOutline = _resolveComponent("IconEmoticonPlusOutline")
  const _component_NcEmojiPicker = _resolveComponent("NcEmojiPicker")
  const _component_ReactionsList = _resolveComponent("ReactionsList")

  return ($options.reactionsCount && $options.reactionsSorted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.reactionsSorted, (reaction) => {
          return (_openBlock(), _createBlock(_component_NcPopover, {
            key: reaction,
            delay: 200,
            "no-focus-trap": "",
            triggers: ['hover'],
            "popper-triggers": ['hover'],
            onAfterShow: $options.fetchReactions
          }, {
            trigger: _withCtx(() => [
              _createVNode(_component_NcButton, {
                variant: $options.userHasReacted(reaction) ? 'primary' : 'secondary',
                class: "reaction-button--trigger",
                size: "small",
                onClick: $event => ($options.handleReactionClick(reaction))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(reaction), 1),
                  _createTextVNode(" " + _toDisplayString($options.reactionsCount(reaction)), 1)
                ]),
                _: 2
              }, 1032, ["variant", "onClick"])
            ]),
            default: _withCtx(() => [
              ($options.hasReactionsLoaded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString($options.getReactionSummary(reaction)) + " ", 1),
                      ($options.reactionsCount(reaction) === 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($options.remainingReactionsLabel(reaction)), 1))
                        : ($options.reactionsCount(reaction) > 4)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "more-reactions-button",
                              role: "button",
                              tabindex: "0",
                              onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($data.showAllReactions = true), ["prevent"]))
                            }, _toDisplayString($options.remainingReactionsLabel(reaction)), 1))
                          : _createCommentVNode("", true)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_NcLoadingIcon)
                  ]))
            ]),
            _: 2
          }, 1032, ["onAfterShow"]))
        }), 128)),
        ($props.showControls)
          ? (_openBlock(), _createBlock(_component_NcButton, {
              key: 0,
              size: "small",
              title: $options.t('spreed', 'Show all reactions'),
              "aria-label": $options.t('spreed', 'Show all reactions'),
              onClick: _cache[1] || (_cache[1] = $event => ($data.showAllReactions = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconHeartOutline, { size: 15 })
              ]),
              _: 1
            }, 8, ["title", "aria-label"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_6)),
        ($props.canReact && $props.showControls)
          ? (_openBlock(), _createBlock(_component_NcEmojiPicker, {
              key: 2,
              "per-line": 5,
              onSelect: $options.handleReactionClick,
              onAfterShow: $options.emitEmojiPickerStatus,
              onAfterHide: $options.emitEmojiPickerStatus
            }, {
              default: _withCtx(() => [
                _createVNode(_component_NcButton, {
                  size: "small",
                  class: "reaction-button--trigger",
                  title: $options.t('spreed', 'Add more reactions'),
                  "aria-label": $options.t('spreed', 'Add more reactions')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconEmoticonPlusOutline, { size: 15 })
                  ]),
                  _: 1
                }, 8, ["title", "aria-label"])
              ]),
              _: 1
            }, 8, ["onSelect", "onAfterShow", "onAfterHide"]))
          : ($props.canReact)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7))
            : _createCommentVNode("", true),
        ($data.showAllReactions)
          ? (_openBlock(), _createBlock(_component_ReactionsList, {
              key: 4,
              token: $props.token,
              "detailed-reactions": $options.detailedReactions,
              "reactions-sorted": $options.reactionsSorted,
              onClose: _cache[2] || (_cache[2] = $event => ($data.showAllReactions = false))
            }, null, 8, ["token", "detailed-reactions", "reactions-sorted"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}